<template>

  <day-base-bar>
    <div class="fill-height text-center" :style="`background-color: rgb(from ${item.color} r g b / 40%)`">
      On-Demand ({{ item.spacesSold }})
    </div>
  </day-base-bar>

</template>

<script setup lang="ts">

import DayBaseBar from './DayBaseBar.vue'
import type { DayOnDemandInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: DayOnDemandInventoryCalendarItem
}

defineProps<Props>()

</script>
